package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{className, table, tbody, td, tr}

@react object Table {
	case class Props(children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>
		table(className := defaultTableClass)(
			tbody(
				props.children:_*
			)
		)
	}

	private val defaultTableClass = "efactory-table"
}

@react object TableHeader {
	case class Props(children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>
		tr(className := defaultTableHeaderRowClass)(
			props.children:_*
		)
	}

	private val defaultTableHeaderRowClass = "efactory-table-header-row"
}

@react object TableRow {
	case class Props(children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>
		tr(className := defaultTableRowClass)(
			props.children:_*
		)
	}

	private val defaultTableRowClass = "efactory-table-row"
}

@react object TableCell {
	case class Props(children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>
		td(
			props.children:_*
		)
	}
}
